/*
 * Copyright © 2018 Aram Meem Company Limited.  All Rights Reserved.
 */

export enum OrderState {
  PREPARE = 'PREPARE',
  ON_THE_WAY = 'ON_THE_WAY',
  DELIVERED = 'DELIVERED',
  CANCELED = 'CANCELED',
  WAIT_CUSTOMER_LOCATION = 'WAIT_CUSTOMER_LOCATION',
}

export enum OrderStatus {
  ACCEPTED = 'ACCEPTED',
  AT_DROP_OFF = 'AT_DROP_OFF',
  AT_PICK_UP = 'AT_PICK_UP',
  AT_SERVICE_POINT = 'AT_SERVICE_POINT',
  CANCEL_REQUESTED = 'CANCEL_REQUESTED',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  COST_APPROVED = 'COST_APPROVED',
  COST_DECLINED = 'COST_DECLINED',
  DRIVER_CHANGED = 'DRIVER_CHANGED',
  DRIVER_COMPLETED = 'DRIVER_COMPLETED',
  NEW = 'NEW',
  NOT_CONFIRMED = 'NOT_CONFIRMED',
  ON_THE_WAY_TO_DROP_OFF = 'ON_THE_WAY_TO_DROP_OFF',
  ON_THE_WAY_TO_PICK_UP = 'ON_THE_WAY_TO_PICK_UP',
  ON_THE_WAY_TO_SERVICE_POINT = 'ON_THE_WAY_TO_SERVICE_POINT',
  PAID = 'PAID',
  POS_CHANGE_APPROVED = 'POS_CHANGE_APPROVED',
  POS_CHANGE_DECLINED = 'POS_CHANGE_DECLINED',
  READY_TO_EXECUTE = 'READY_TO_EXECUTE',
  RECIEPT_SENT = 'RECIEPT_SENT',
  SUSPENDED = 'SUSPENDED',
  TO_SUPPORT = 'TO_SUPPORT',
  WAIT_COST_APPROVAL = 'WAIT_COST_APPROVAL',
  WAIT_MERCHANT_APPROVAL = 'WAIT_MERCHANT_APPROVAL',
  WAIT_POS_CHANGE_APPROVAL = 'WAIT_POS_CHANGE_APPROVAL',
}



// WEBPACK FOOTER //
// ./src/app/types.ts